var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("params"),_c('div',{staticClass:"bar-container"},[_c('div',{class:_vm.barColor,style:('width:' + _vm.chartValue + '%;')})])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }